import Enumerable from "linq";
import { IDisabledScheduleDTO, ISetPointViewModel } from "../../services/alarm-setpoints-data-service/Models";

export enum AlarmState {
    InAlarm = 0,
    Acknowledged = 1,
    Disabled = 2,
    NotInAlarm = 3
}

export type AlarmSetpoint = ISetPointViewModel & { groupKey: number; };

export type UseAlarmSetpointsReturnType = {
    alarmSetpoints: Array<AlarmSetpoint>;
    totalCount: number;
    filteredCount: number;
};

export type UseAlarmSetpointsOptionsType = {
    filterText: string;
    orderByAlarmState: boolean;
};

export type DisabledScheduleMutationContextType = {
    previousSchedule: IDisabledScheduleDTO | undefined;
};

export function selectAlarmSetpoints(data: Array<ISetPointViewModel>, options?: UseAlarmSetpointsOptionsType): UseAlarmSetpointsReturnType {

    const filterText = options?.filterText.toLowerCase() ?? "";

    const shapedData = data?.map(item => {
        return {
            ...item,
            groupKey: getAlarmState(item)
        } as AlarmSetpoint;
    }) ?? new Array<ISetPointViewModel>();

    const filteredData = shapedData.filter(item => {
        return (item.tagName?.toLowerCase().indexOf(filterText) ?? -1) !== -1 ||
            (item.setPointName?.toLowerCase().indexOf(filterText) ?? -1) !== -1;
    });

    const orderedData = filteredData
        ? options?.orderByAlarmState
            ? Enumerable
                .from(filteredData)
                .orderBy(o => {
                    return getAlarmState(o);
                })
                .thenBy(o => o.tagName)
                .thenBy(o => o.setPointName)
                .toArray()
            : Enumerable
                .from(filteredData)
                .orderBy(o => o.tagName)
                .thenBy(o => o.setPointName)
                .toArray()
        : new Array<AlarmSetpoint>();

    return {
        alarmSetpoints: orderedData,
        totalCount: data?.length ?? 0,
        filteredCount: filteredData.length ?? 0
    };
}

export function getAlarmState(item: ISetPointViewModel): AlarmState {
    return item.disabled
        ? AlarmState.Disabled
        : item.alarmAcknowledged && item.inAlarm
            ? AlarmState.Acknowledged
            : item.inAlarm
                ? AlarmState.InAlarm
                : AlarmState.NotInAlarm;
}
